import React from "react";
import { Tooltip } from "@mui/material";

import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";

import CustomDownload from "../../common/commonComponents/CustomDownload";
import ALoader from "../../common/a-loader";
import { LastUpdatedDetails } from "../userProfile/helper";

const TableContent = ({
  rows,
  rowCount,
  isLoading,
  currentPage,
  onPageChange,
  userPermissions,
}) => {
  const columns = [
    new AGridColDef("serialNum", "S.No.")
      .setMinWidth(20)
      .setFlex(0.4)
      .renderCellComponent((params) => {
        return <div>{params.value}</div>;
      }),

    new AGridColDef("processInstanceId", "Process ID")
      .setMinWidth(150)
      .setFlex(0.5)
      .renderCellComponent((params) => params?.value || "-"),

    new AGridColDef("description", "Description")
      .setMinWidth(200)
      .setFlex(0.5)
      .renderCellComponent((params) => (
        <Tooltip title={params?.value}>{params?.value || "-"}</Tooltip>
      )),

    new AGridColDef("fileName", "File Name")
      .setMinWidth(100)
      .renderCellComponent((params) => (
        <Tooltip title={params?.value}>{params?.value || "-"}</Tooltip>
      )),

    new AGridColDef("updatedOn", "Last updated on")
      .setMinWidth(400)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip
            title={LastUpdatedDetails(params?.value, params?.row.updatedBy)}
          >
            <div className={`ellipsis-text-container`}>
              {LastUpdatedDetails(params?.value, params?.row.updatedBy)}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("status", "Status")
      .setMinWidth(50)
      .renderCellComponent((params) => (
        <div className="text-capitalize">{params?.value}</div>
      )),

    ...(userPermissions?.includes("C") || userPermissions?.includes("U")
      ? [
          new AGridColDef("errorPath", "Error")
            .setMinWidth(50)
            .setFlex(0.5)
            .columnAlign("center")
            .renderCellComponent((params) =>
              params?.value ? (
                <CustomDownload
                  downloadKey={params?.value}
                  isIcon={true}
                  permissionSet={userPermissions}
                  permissionType={"C"}
                />
              ) : (
                <div className="m-auto">-</div>
              )
            ),

          new AGridColDef("fileKey", "Action")
            .setMinWidth(50)
            .setFlex(0.5)
            .columnAlign("center")
            .renderCellComponent((params) => (
              <div>
                <CustomDownload
                  downloadKey={params?.value}
                  isIcon={true}
                  permissionSet={userPermissions}
                  permissionType={"C"}
                />
              </div>
            )),
        ]
      : []),
  ];

  return (
    <div className="mt-3" style={{ height: "100%" }}>
      {isLoading ? (
        <ALoader />
      ) : (
        <ADataGrid
          removeWrapperContainer
          // rowModesModel={rowModesModel}
          rows={rows || []}
          columns={columns}
          rowId={(row) => row.id}
          rowHeight={50}
          loading={isLoading}
          rowCount={rowCount}
          nextButtonHandler={onPageChange}
          currentPage={currentPage}
          height="100%"
        />
      )}
    </div>
  );
};

export default TableContent;
